import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
//import PerfectScrollbar from "perfect-scrollbar";
//import "perfect-scrollbar/css/perfect-scrollbar.css";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// custom components
import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
//import image from "assets/img/sidebar-2.jpg";
import Sidebar from "components/react-custom-template/Sidebar/Sidebar";
import Header from "components/react-custom-template/Header/Header";
import MainLoadingIndicator from "components/common/loading/MainLoadingIndicator";
import Main from "views/layout/Main";
import Notification from "views/notification/Notification";
import { toggleSidebar } from "store/actions/sidebarActions";
//import logo from "assets/img/logo-white.svg";

// util
import { getTopMenu } from "util/common";

/**
 * material-dashboard-pro-react-v1.5.0 > Dashboard.jsx 참고
 */
//var ps;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileSidebarOpen: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }

  componentDidMount() {
    console.log("Index > index mount");
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps = new PerfectScrollbar(this.refs.mainPanel, {
    //     suppressScrollX: true,
    //     suppressScrollY: false
    //   });
    //   document.body.style.overflow = "hidden";
    // }
    window.addEventListener("resize", this.resizeFunction);
  }

  componentWillUnmount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps.destroy();
    // }
    window.removeEventListener("resize", this.resizeFunction);
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.isMobileSidebarOpen) {
        this.setState({ isMobileSidebarOpen: false });
      }
    }
  }

  handleToggleMobileSidebar = () => {
    this.setState({ isMobileSidebarOpen: !this.state.isMobileSidebarOpen });
  };

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ isMobileSidebarOpen: false });
    }
  }

  render() {

    const {
      classes,
      isSidebarOpen,
      selectedSidebarItem,
      dispatchToggleSidebar,
      ...rest
    } = this.props;
    const { isMobileSidebarOpen } = this.state;

    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: !isSidebarOpen
        // [classes.mainPanelWithPerfectScrollbar]:
        //   navigator.platform.indexOf("Win") > -1
      });
    const topMenu = getTopMenu(this.props.location.pathname);

    return (
      <div className={classes.wrapper}>
        <Sidebar
          //image={image}
          bgColor="black"
          color="white"
          onToggleMobileSidebar={this.handleToggleMobileSidebar}
          isMobileSidebarOpen={isMobileSidebarOpen}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            isSidebarOpen={isSidebarOpen}
            selectedSidebarItem={selectedSidebarItem}
            topMenu={topMenu}
            onToggleSidebar={dispatchToggleSidebar}
            onToggleMobileSidebar={this.handleToggleMobileSidebar}
            {...rest}
          />
          <div className={classes.content}>
            {/* <div className={classes.container}> */}
            <MainLoadingIndicator isSidebarOpen={isSidebarOpen} />
            <Main />
            {/* </div> */}
          </div>
        </div>
        <Notification />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withStyles(appStyle),
  connect(
    (state, props) => ({
      selectedSidebarItem: state.sidebar.selectedSidebarItem,
      isSidebarOpen: state.sidebar.sidebarOpen,
    }),
    {
      dispatchToggleSidebar: toggleSidebar
    }
  )
)(Index);
